<template>
  <div>
    <page-title :title="title"></page-title>
    <div v-for="film in films" :key="film.id" class="film">
      <a :href="filmUrl(film.id)" target="_blank">
        <img v-if="tmdb.config" :src="imageUrl(film.backdrop_path)">
      </a>
      <br>
      {{ film.original_title }}
    </div>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  export default {
    name: 'last-ten-films',
    props: {
      listId: {
        type: String,
        required: true
      },
      apiKey: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        title: 'Last ten films',
        films: [],
        tmdb: {
          secure_base_url: 'https://www.themoviedb.org/',
          secure_base_api_url: 'https://api.themoviedb.org/',
          api_key: this.apiKey,
          list_id: this.listId,
          config: null
        }
      }
    },
    created () {
      this.axios.get(this.configurationUrl)
      .then(response => {
        this.tmdb.config = response.data
        return this.axios.get(this.listUrl)
      })
      .then(response => {
        response.data.results.slice(0, 10).map((film) => { this.films.push(film) })
      })
      .catch(e => {
        console.log(e)
      })
    },
    methods: {
      filmUrl (filmId) {
        return this.tmdb.secure_base_url + 'movie/' + filmId
      },
      imageUrl (relativePath) {
        return this.tmdb.config.images.secure_base_url + 'w500' + relativePath
      }
    },
    computed: {
      configurationUrl () {
        return this.tmdb.secure_base_api_url + '3/configuration?api_key=' + this.tmdb.api_key
      },
      listUrl () {
        return this.tmdb.secure_base_api_url + '4/list/' + this.tmdb.list_id + '?page=1&api_key=' + this.tmdb.api_key
      }
    },
    components: {
      PageTitle
    }
  }
</script>

<style>
.film {
  margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// LastTenFilms.vue?3a23a676